import { connectarun } from "../../assets";
import Section from "../Section";
import ScrollToTop from "react-scroll-to-top";

const Connect = () => {
  return (
    <Section className="bg-[#456dff]">
      <div className="container">
        <div className="flex justify-between items-center">
          <div className="relative z-1 max-w-[50rem]">
            <h4 className="text-base text-black">LET’S CONNECT!</h4>
            <h2 className="h2 mb-[1rem] md:mb-10 lg:mb-[1.4rem]">
              Get a 30 minutes <span className="text-[#000]">consultation</span>
            </h2>

            <div className="flex-auto flex-wrap gap-x-2">
              <p className="leading-8 text-[#fff]">
                Thank you for being here. To discuss about your business
                objectives, a new campaign, creative project and how we could
                help you. Speak to Arun Mandru, our Creative Director.
              </p>
            </div>
          </div>

          <div className="flex relative z-2 p-5 md:p-0 text-center">
            <div className="flex-row gap-2 mb-10">
              <div className="block relative p-0.5">
                <div className="relative z-2 flex flex-col pointer-events-none">
                  <img
                    src={connectarun}
                    width={180}
                    height={180}
                    className="h-full object-cover rounded-full"
                  />
                </div>
              </div>
              <div className="flex-auto flex-wrap gap-x-2 mt-3">
                <h4 className="text-lg text-black uppercase">Arun Mandru</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ScrollToTop
        smooth
        width="24"
        height="24"
        viewBox="0 0 25 15"
        svgPath="M0 12.5L12.5 0L25 12.5L22.5 15L12.5 5L2.5 15L0 12.5Z"
        color="#fff"
        className="chorus-scroll-top flex items-center justify-center"
      />
    </Section>
  );
};

export default Connect;
